import React from 'react';
import { Modal } from '@stormwater-software/lib-ui';

export interface IClearComplianceComfirmationModalProps {
  onClose: () => void;
  Submit: () => void;
  inspections: string[];
}

const ClearComplianceComfirmationModal: React.FC<
  IClearComplianceComfirmationModalProps
> = ({ onClose, Submit, inspections }) => {
  const onSubmit = async () => {
    Submit();
  };

  return (
    <Modal
      title='Submit Finding Confirmation here'
      subTitle={`Are you sure you want to submit the finding? The following inspections  will have their compliance signatures removed. This action cannot be undone.`}
      show={true}
      submitBtnText='Confirm'
      handleSubmit={onSubmit}
      handleClose={onClose}
      cancelBtn={true}
    >
      <ul>
        {inspections.map((inspection, index) => (
          <li key={index}>Inspection {inspection}</li>
        ))}
      </ul>
    </Modal>
  );
};

export default ClearComplianceComfirmationModal;
